import { Link } from 'react-router-dom';
import { Github, Twitter, Linkedin, Mail } from 'lucide-react';
import Logo from '../../brand/logo.svg';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'Cloud Infra', path: '/cloud-infra' },
      { name: 'AI Agents', path: '/ai-agents' },
      { name: 'Automations', path: '/automations' },
      { name: 'Analytics', path: '/analytics' },
      { name: 'Projects', path: '/projects' },
    ],
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Contact', path: '/contact' },
    ],
  };

  const socialLinks = [
    { icon: Github, href: 'https://github.com/STARZVentures', label: 'GitHub' },
    { icon: Twitter, href: 'https://twitter.com', label: 'Twitter' },
    { icon: Linkedin, href: 'https://www.linkedin.com/company/starzai/posts/?feedView=all', label: 'LinkedIn' },
    { icon: Mail, href: 'mailto:apps@starztech.uk', label: 'Email' },
  ];

  return (
    <footer className="relative bg-dark-surface-100 border-t border-glass-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-3 mb-4">
              <img src="/logo.png" alt="STARZ Tech" className="h-16 w-auto" />
              <span className="text-2xl font-bold text-text-primary dark:text-white">STARZ TECH</span>
            </Link>
            <p className="text-text-secondary text-body-sm mb-4 max-w-sm">
              Building the future with cutting-edge technology and innovative solutions.
              Transforming ideas into reality.
            </p>
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 glass-morphism rounded-lg hover:bg-neon-purple/10 hover:border-neon-purple transition-all duration-300 group"
                    aria-label={social.label}
                  >
                    <Icon size={18} className="text-text-secondary group-hover:text-neon-purple transition-colors" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h3 className="text-text-primary font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-text-secondary text-body-sm hover:text-neon-purple transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-text-primary font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-text-secondary text-body-sm hover:text-neon-purple transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-glass-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-text-muted text-body-sm">
              Â© {currentYear} STARZ Tech. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy-policy" className="text-text-muted text-body-sm hover:text-neon-purple transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-text-muted text-body-sm hover:text-neon-purple transition-colors">
                Terms of Service
              </Link>
              <Link to="/cookie-policy" className="text-text-muted text-body-sm hover:text-neon-purple transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Gradient */}
    </footer>
  );
};

export default Footer;

